import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import size from '../../utills/size'

export const storeLocatorBanner = {
    position: 'relative',
    paddingTop: pxToRem(20),
    paddingBottom: pxToRem(30),
    h1: {
        color: 'white',
        position: 'absolute',
        top: '50%',
        left: '35%',
        transform: 'translateY(-50%)',
        lineHeight: pxToRem(18),
        letterSpacing: pxToRem(3.9),
        textTransform: 'uppercase',
        fontWeight: 700,
        fontSize: pxToRem(15),
        margin: 0,
        [`@media (min-width: ${size.md})`]: {
            fontSize: pxToRem(30)
        },
        [`@media (min-width: ${size.lg})`]: {
            fontSize: pxToRem(40)
        }
    },
    img: {
        with: '100%'
    }
}
export const storeSelectorButton = {
    '.findStores.button-primary': {
        minWidth: 'inherit',
        width: '100%',
        marginTop: pxToRem(25),
        [`@media (min-width: ${size.lg})`]: {
            width: 'inherit',
            padding: `0 ${pxToRem(41)}`
        }
    },
    '.findStores.button-tertiary': {
        minWidth: 'inherit',
        width: '100%',
        marginTop: pxToRem(25),
        [`@media (min-width: ${size.lg})`]: {
            width: 'inherit'
        }
    }
}

export const selectOptionStyles = {
    fontWeight: 400,
    fontSize: pxToRem(12)
}

export const storeDetailsButton = {
    width: '100%',
    '.storeDetails.button-primary, .storeDetails.button-tertiary': {
        display: 'block',
        width: '100%',
        fontSize: pxToRem(14),
        letterSpacing: pxToRem(1)
    }
}

export const stateContentStyles = {
    h2: {
        fontSize: pxToRem(28),
        lineHeight: pxToRem(30),
        letterSpacing: pxToRem(1),
        fontWeight: 700,
        color: 'cav_light_black',
        margin: `${pxToRem(24)} 0`,

        [`@media (min-width: ${size.lg})`]: {
            fontSize: pxToRem(16),
            lineHeight: pxToRem(18),
            margin: `${pxToRem(12)} 0`
        }
    },
    p: {
        fontSize: pxToRem(15),
        lineHeight: pxToRem(21),
        letterSpacing: pxToRem(1),
        paddingBottom: 0,
        color: 'cav_light_black',
        margin: pxToRem(15)
    }
}

export const storeHoursStyles = {
    padding: 0,
    display: 'flex',
    gap: pxToRem(6),
    'div:nth-of-type(2)': {
        width: '100%'
    },
    table: {
        tr: {
            'td, th': {
                borderWidth: 0,
                paddingTop: pxToRem(5),
                paddingBottom: pxToRem(5),
                fontFamily: fonts.primary,
                fontSize: [`${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`, `${pxToRem(14)}`],
                fontWeight: 500,
                letterSpacing: pxToRem(1),
                lineHeight: pxToRem(16.8),
                color: 'cav_light_black',
                paddingLeft: pxToRem(3.5),
                paddingRight: pxToRem(3.5)
            },
            th: {
                fontWeight: 700,
                letterSpacing: 'normal'
            },
            'td:nth-of-type(1), th:nth-of-type(1)': {
                paddingLeft: pxToRem(0),
                fontWeight: 700
            }
        }
    }
}
